module.exports = __webpack_public_path__ + "img/fontawesome-webfont.svg?912ec66d7572ff821749319396470bde";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 598
// module chunks = 0